var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function Mail(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { id: "mail_FILL0_wght400_GRAD0_opsz48 1" },
            React.createElement("path", { id: "Vector", d: "M2.33301 14.0252C2.06634 14.0252 1.83301 13.9252 1.63301 13.7252C1.43301 13.5252 1.33301 13.2919 1.33301 13.0252V4.35858C1.33301 4.09191 1.43301 3.85858 1.63301 3.65858C1.83301 3.45858 2.06634 3.35858 2.33301 3.35858H13.6663C13.933 3.35858 14.1663 3.45858 14.3663 3.65858C14.5663 3.85858 14.6663 4.09191 14.6663 4.35858V13.0252C14.6663 13.2919 14.5663 13.5252 14.3663 13.7252C14.1663 13.9252 13.933 14.0252 13.6663 14.0252H2.33301ZM7.99967 8.99191L2.33301 5.27525V13.0252H13.6663V5.27525L7.99967 8.99191ZM7.99967 7.99191L13.5997 4.35858H2.41634L7.99967 7.99191ZM2.33301 5.27525V4.35858V13.0252V5.27525Z", fill: fillColor, fillOpacity: "0.6" }))));
}
export default memo(withIconDefaults(Mail));
